// extracted by mini-css-extract-plugin
export var boldText = "_38-4";
export var checkboxContainer = "_38-6";
export var closeIcon = "_38-i";
export var container = "_38-0";
export var drawer = "_38-8";
export var drawerContent = "_38-9";
export var extraSmallText = "_38-5";
export var fulfillmentGroupTable = "_38-e";
export var largeText = "_38-3";
export var loadingSpinnerContainer = "_38-j";
export var mediumText = "_38-2";
export var narrow = "_38-f";
export var notificationLink = "_38-l";
export var packageCheckIconContainer = "_38-7";
export var slideoutHeaderActions = "_38-g";
export var slideoutHeaderActionsShifted = "_38-h";
export var slideoutHeaderContainer = "_38-a";
export var slideoutModal = "_38-c";
export var stickyHeaderWrapper = "_38-b";
export var table = "_38-k";
export var tableContainer = "_38-d";
export var tertiaryText = "_38-1";